module.exports = __webpack_public_path__ + "static/media/be.6f7c349f.png";